export default {

    speed: {x: 2, y: 0},
    deepStartMove: 1.1,
    deepChangeAnimation: 20,
    land:[
        {x: -0.01, y: -0.01},
         {x: -0.05, y: -0.05},
         {x: -0.12, y: -0.12},
         {x: -0.22, y: -0.22},
         {x: -0.35, y: -0.35},
         {x: -0.49, y: -0.49},
         {x: -0.67, y: -0.67},
         {x: -0.87, y: -0.87},
         {x: -1.11, y: -1.11},
         {x: -1.36, y: -1.36},
         {x: -1.65, y: -1.65},
         {x: -1.96, y: -1.96},
         {x: -2.3, y: -2.3},
         {x: -2.68, y: -2.68},
         {x: -3.08, y: -3.08},
         {x: -3.48, y: -3.48},
         {x: -3.92, y: -3.92},
         {x: -4.39, y: -4.39},
         {x: -4.9, y: -4.9},
         {x: -5.43, y: -5.43},
         {x: -5.99, y: -5.99},
         {x: -6.59, y: -6.59},
         {x: -7.19, y: -7.19},
         {x: -7.8, y: -7.8},
         {x: -8.47, y: -8.47},
         {x: -9.15, y: -9.15},
         {x: -9.88, y: -9.88},
         {x: -10.61, y: -10.61},
         {x: -11.37, y: -11.37},
         {x: -12.18, y: -12.18},
         {x: -13.01, y: -13.01},
         {x: -13.85, y: -13.85},
         {x: -14.74, y: -14.74},
         {x: -15.62, y: -15.62},
         {x: -16.51, y: -16.51},
         {x: -17.5, y: -17.5},
         {x: -18.44, y: -18.44},
         {x: -19.43, y: -19.43},
         {x: -20.47, y: -20.47},
         {x: -21.54, y: -21.54},
         {x: -22.61, y: -22.61},
         {x: -23.66, y: -23.66},
         {x: -24.81, y: -24.81},
         {x: -25.98, y: -25.98},
         {x: -27.15, y: -27.15},
         {x: -28.37, y: -28.37},
         {x: -29.58, y: -29.58},
         {x: -30.82, y: -30.82},
         {x: -32.08, y: -32.08},
         {x: -33.4, y: -33.4},
         {x: -34.75, y: -34.75},
         {x: -36.08, y: -36.08},
         {x: -37.48, y: -37.48},
         {x: -38.86, y: -38.86},
         {x: -40.26, y: -40.26},
         {x: -41.69, y: -41.69},
         {x: -43.18, y: -43.18},
         {x: -44.66, y: -44.66},
         {x: -46.2, y: -46.2},
         {x: -47.72, y: -47.72},
         {x: -49.26, y: -49.26},
         {x: -50.87, y: -50.87},
         {x: -52.46, y: -52.46},
         {x: -54.06, y: -54.06},
         {x: -55.74, y: -55.74},
         {x: -57.4, y: -57.4},
         {x: -59.07, y: -59.07},
         {x: -60.82, y: -60.82},
         {x: -62.53, y: -62.53},
         {x: -64.33, y: -64.33},
         {x: -66.03, y: -66.03},
         {x: -67.87, y: -67.87},
         {x: -69.67, y: -69.67},
         {x: -71.54, y: -71.54},
         {x: -73.39, y: -73.39},
         {x: -75.31, y: -75.31},
         {x: -77.13, y: -77.13},
         {x: -79.09, y: -79.09},
         {x: -81.02, y: -81.02},
         {x: -82.96, y: -82.96},
         {x: -84.98, y: -84.98},
         {x: -86.96, y: -86.96},
         {x: -88.96, y: -88.96},
         {x: -91.04, y: -91.04},
         {x: -93.08, y: -93.08},
         {x: -95.2, y: -95.2},
         {x: -97.27, y: -97.27},
         {x: -99.37, y: -99.37},
         {x: -101.61, y: -101.61},
         {x: -103.67, y: -103.67},
         {x: -105.82, y: -105.82},
         {x: -108.05, y: -108.05},
         {x: -110.23, y: -110.23},
         {x: -112.43, y: -112.43},
         {x: -114.71, y: -114.71},
         {x: -116.94, y: -116.94},
         {x: -119.19, y: -119.19},
         {x: -121.52, y: -121.52},
         {x: -123.8, y: -123.8},
         {x: -126.17, y: -126.17},
         {x: -128.48, y: -128.48},
         {x: -130.81, y: -130.81},
         {x: -133.29, y: -133.29},
         {x: -135.58, y: -135.58},
         {x: -137.95, y: -137.95},
         {x: -140.41, y: -140.41},
         {x: -142.89, y: -142.89},
         {x: -145.23, y: -145.23},
         {x: -147.8, y: -147.8},
         {x: -150.25, y: -150.25},
         {x: -152.7, y: -152.7},
         {x: -155.17, y: -155.17},
         {x: -157.73, y: -157.73},
         {x: -160.15, y: -160.15},
         {x: -162.81, y: -162.81},
         {x: -165.26, y: -165.26},
         {x: -167.86, y: -167.86},
         {x: -170.49, y: -170.49},
         {x: -173.04, y: -173.04},
         {x: -175.61, y: -175.61},
         {x: -178.27, y: -178.27},
         {x: -180.78, y: -180.78},
         {x: -183.53, y: -183.53},
         {x: -186.07, y: -186.07},
         {x: -188.77, y: -188.77},
         {x: -191.4, y: -191.4},
         {x: -194.04, y: -194.04},
         {x: -196.85, y: -196.85},
         {x: -199.43, y: -199.43},
         {x: -202.18, y: -202.18},
         {x: -204.85, y: -204.85},
         {x: -207.62, y: -207.62},
         {x: -210.32, y: -210.32},
         {x: -213.1, y: -213.1},
         {x: -215.81, y: -215.81},
         {x: -218.61, y: -218.61},
         {x: -221.25, y: -221.25},
         {x: -223.98, y: -223.98},
         {x: -226.8, y: -226.8},
         {x: -229.63, y: -229.63},
         {x: -232.3, y: -232.3},
         {x: -235.06, y: -235.06},
         {x: -237.91, y: -237.91},
         {x: -240.76, y: -240.76},
         {x: -243.45, y: -243.45},
         {x: -246.31, y: -246.31},
         {x: -249.18, y: -249.18},
         {x: -252.05, y: -252.05},
         {x: -254.76, y: -254.76},
         {x: -257.56, y: -257.56},
         {x: -260.45, y: -260.45},
         {x: -263.25, y: -263.25},
         {x: -266.06, y: -266.06},
         {x: -269.04, y: -269.04},
         {x: -271.85, y: -271.85},
         {x: -274.58, y: -274.58},
         {x: -277.4, y: -277.4},
         {x: -280.39, y: -280.39},
         {x: -283.13, y: -283.13},
         {x: -286.12, y: -286.12},
         {x: -288.86, y: -288.86},
         {x: -291.69, y: -291.69},
         {x: -294.6, y: -294.6},
         {x: -297.52, y: -297.52},
         {x: -300.34, y: -300.34},
         {x: -303.17, y: -303.17},
         {x: -306, y: -306},
         {x: -309, y: -309},
         {x: -311.74, y: -311.74},
         {x: -314.65, y: -314.65},
         {x: -317.38, y: -317.38},
         {x: -320.29, y: -320.29},
         {x: -323.2, y: -323.2},
         {x: -326.01, y: -326.01},
         {x: -328.91, y: -328.91},
         {x: -331.81, y: -331.81},
         {x: -334.62, y: -334.62},
         {x: -337.34, y: -337.34},
         {x: -340.32, y: -340.32},
         {x: -343.12, y: -343.12},
         {x: -345.83, y: -345.83},
         {x: -348.71, y: -348.71},
         {x: -351.49, y: -351.49},
         {x: -354.36, y: -354.36},
         {x: -357.06, y: -357.06},
         {x: -359.91, y: -359.91},
         {x: -362.68, y: -362.68},
         {x: -365.53, y: -365.53},
         {x: -368.28, y: -368.28},
         {x: -371.12, y: -371.12},
         {x: -373.86, y: -373.86},
         {x: -376.68, y: -376.68},
         {x: -379.33, y: -379.33},
         {x: -382.13, y: -382.13},
         {x: -384.93, y: -384.93},
         {x: -387.64, y: -387.64},
         {x: -390.42, y: -390.42},
         {x: -393.11, y: -393.11},
         {x: -395.8, y: -395.8},
         {x: -398.55, y: -398.55},
         {x: -401.14, y: -401.14},
         {x: -403.88, y: -403.88},
         {x: -406.6, y: -406.6},
         {x: -409.24, y: -409.24},
         {x: -411.87, y: -411.87},
         {x: -414.49, y: -414.49},
         {x: -417.1, y: -417.1},
         {x: -419.69, y: -419.69},
         {x: -422.36, y: -422.36},
         {x: -425.09, y: -425.09},
         {x: -427.58, y: -427.58},
         {x: -430.13, y: -430.13},
         {x: -432.75, y: -432.75},
         {x: -435.28, y: -435.28},
         {x: -437.95, y: -437.95},
         {x: -440.38, y: -440.38},
         {x: -442.87, y: -442.87},
         {x: -445.43, y: -445.43},
         {x: -447.89, y: -447.89},
         {x: -450.42, y: -450.42},
         {x: -452.79, y: -452.79},
         {x: -455.36, y: -455.36},
         {x: -457.7, y: -457.7},
         {x: -460.1, y: -460.1},
         {x: -462.55, y: -462.55},
         {x: -464.92, y: -464.92},
         {x: -467.28, y: -467.28},
         {x: -469.76, y: -469.76},
         {x: -472.01, y: -472.01},
         {x: -474.39, y: -474.39},
         {x: -476.68, y: -476.68},
         {x: -479.03, y: -479.03},
         {x: -481.22, y: -481.22},
         {x: -483.6, y: -483.6},
         {x: -485.9, y: -485.9},
         {x: -488.11, y: -488.11},
         {x: -490.3, y: -490.3},
         {x: -492.48, y: -492.48},
         {x: -494.64, y: -494.64},
         {x: -496.85, y: -496.85},
         {x: -498.97, y: -498.97},
         {x: -501.14, y: -501.14},
         {x: -503.17, y: -503.17},
         {x: -505.3, y: -505.3},
         {x: -507.42, y: -507.42},
         {x: -509.45, y: -509.45},
         {x: -511.46, y: -511.46},
         {x: -513.52, y: -513.52},
         {x: -515.44, y: -515.44},
         {x: -517.51, y: -517.51},
         {x: -519.45, y: -519.45},
         {x: -521.37, y: -521.37},
         {x: -523.27, y: -523.27},
         {x: -525.15, y: -525.15},
         {x: -527.12, y: -527.12},
         {x: -528.9, y: -528.9},
         {x: -530.72, y: -530.72},
         {x: -532.57, y: -532.57},
         {x: -534.34, y: -534.34},
         {x: -536.15, y: -536.15},
         {x: -537.88, y: -537.88},
         {x: -539.65, y: -539.65},
         {x: -541.29, y: -541.29},
         {x: -543.01, y: -543.01},
         {x: -544.65, y: -544.65},
         {x: -546.38, y: -546.38},
         {x: -547.98, y: -547.98},
         {x: -549.51, y: -549.51},
         {x: -551.07, y: -551.07},
         {x: -552.65, y: -552.65},
         {x: -554.17, y: -554.17},
         {x: -555.66, y: -555.66},
         {x: -557.17, y: -557.17},
         {x: -558.61, y: -558.61},
         {x: -560.08, y: -560.08},
         {x: -561.48, y: -561.48},
         {x: -562.85, y: -562.85},
         {x: -564.28, y: -564.28},
         {x: -565.57, y: -565.57},
         {x: -566.87, y: -566.87},
         {x: -568.15, y: -568.15},
         {x: -569.45, y: -569.45},
         {x: -570.75, y: -570.75},
         {x: -571.96, y: -571.96},
         {x: -573.1, y: -573.1},
         {x: -574.26, y: -574.26},
         {x: -575.39, y: -575.39},
         {x: -576.57, y: -576.57},
         {x: -577.65, y: -577.65},
         {x: -578.68, y: -578.68},
         {x: -579.78, y: -579.78},
         {x: -580.81, y: -580.81},
         {x: -581.77, y: -581.77},
         {x: -582.75, y: -582.75},
         {x: -583.71, y: -583.71},
         {x: -584.62, y: -584.62},
         {x: -585.48, y: -585.48},
         {x: -586.38, y: -586.38},
         {x: -587.19, y: -587.19},
         {x: -588.04, y: -588.04},
         {x: -588.79, y: -588.79},
         {x: -589.57, y: -589.57},
         {x: -590.3, y: -590.3},
         {x: -590.98, y: -590.98},
         {x: -591.67, y: -591.67},
         {x: -592.34, y: -592.34},
         {x: -592.98, y: -592.98},
         {x: -593.56, y: -593.56},
         {x: -594.14, y: -594.14},
         {x: -594.7, y: -594.7},
         {x: -595.2, y: -595.2},
         {x: -595.71, y: -595.71},
         {x: -596.18, y: -596.18},
         {x: -596.61, y: -596.61},
         {x: -597.04, y: -597.04},
         {x: -597.41, y: -597.41},
         {x: -597.78, y: -597.78},
         {x: -598.12, y: -598.12},
         {x: -598.42, y: -598.42},
         {x: -598.7, y: -598.7},
         {x: -598.95, y: -598.95},
         {x: -599.18, y: -599.18},
         {x: -599.38, y: -599.38},
         {x: -599.54, y: -599.54},
         {x: -599.69, y: -599.69},
         {x: -599.81, y: -599.81},
         {x: -599.9, y: -599.9},
         {x: -599.96, y: -599.96},
         {x: -600, y: -600}
    ],

    submarine:
        [
             {x: -300, y: -250, rotation: 0},
             {x: -299.93, y: -250.01, rotation: 0},
             {x: -299.7, y: -250.04, rotation: 0},
             {x: -299.26, y: -250.09, rotation: 0},
             {x: -298.69, y: -250.16, rotation: 0.001},
             {x: -297.9, y: -250.26, rotation: 0.001},
             {x: -296.96, y: -250.38, rotation: 0.002},
             {x: -295.8, y: -250.52, rotation: 0.003},
             {x: -294.51, y: -250.69, rotation: 0.003},
             {x: -293.04, y: -250.87, rotation: 0.004},
             {x: -291.34, y: -251.08, rotation: 0.005},
             {x: -289.52, y: -251.31, rotation: 0.007},
             {x: -287.45, y: -251.57, rotation: 0.008},
             {x: -285.28, y: -251.84, rotation: 0.009},
             {x: -282.92, y: -252.13, rotation: 0.011},
             {x: -280.4, y: -252.45, rotation: 0.012},
             {x: -277.7, y: -252.79, rotation: 0.014},
             {x: -274.73, y: -253.16, rotation: 0.016},
             {x: -271.58, y: -253.55, rotation: 0.018},
             {x: -268.35, y: -253.96, rotation: 0.02},
             {x: -264.83, y: -254.4, rotation: 0.022},
             {x: -261.25, y: -254.84, rotation: 0.024},
             {x: -257.48, y: -255.31, rotation: 0.027},
             {x: -253.55, y: -255.81, rotation: 0.029},
             {x: -249.31, y: -256.34, rotation: 0.032},
             {x: -245.02, y: -256.87, rotation: 0.034},
             {x: -240.42, y: -257.45, rotation: 0.037},
             {x: -235.63, y: -258.05, rotation: 0.04},
             {x: -230.81, y: -258.65, rotation: 0.043},
             {x: -225.66, y: -259.29, rotation: 0.046},
             {x: -220.64, y: -259.92, rotation: 0.05},
             {x: -220, y: -260, rotation: 0.05},
             {x: -219.88, y: -259.93, rotation: 0.05},
             {x: -219.52, y: -259.71, rotation: 0.05},
             {x: -218.98, y: -259.39, rotation: 0.051},
             {x: -218.18, y: -258.91, rotation: 0.051},
             {x: -217.18, y: -258.31, rotation: 0.051},
             {x: -215.92, y: -257.55, rotation: 0.052},
             {x: -214.48, y: -256.69, rotation: 0.053},
             {x: -212.82, y: -255.69, rotation: 0.054},
             {x: -210.94, y: -254.56, rotation: 0.055},
             {x: -208.78, y: -253.27, rotation: 0.056},
             {x: -206.46, y: -251.87, rotation: 0.057},
             {x: -203.84, y: -250.3, rotation: 0.058},
             {x: -201.08, y: -248.65, rotation: 0.059},
             {x: -198, y: -246.8, rotation: 0.061},
             {x: -194.8, y: -244.88, rotation: 0.063},
             {x: -191.38, y: -242.83, rotation: 0.064},
             {x: -187.62, y: -240.57, rotation: 0.066},
             {x: -183.88, y: -238.33, rotation: 0.068},
             {x: -179.55, y: -235.73, rotation: 0.07},
             {x: -175.38, y: -233.23, rotation: 0.072},
             {x: -170.72, y: -230.43, rotation: 0.075},
             {x: -165.98, y: -227.59, rotation: 0.077},
             {x: -160.86, y: -224.52, rotation: 0.08},
             {x: -155.68, y: -221.41, rotation: 0.082},
             {x: -150.28, y: -218.17, rotation: 0.085},
             {x: -144.48, y: -214.69, rotation: 0.088},
             {x: -138.64, y: -211.18, rotation: 0.091},
             {x: -132.39, y: -207.43, rotation: 0.094},
             {x: -126.1, y: -203.66, rotation: 0.097},
             {x: -119.52, y: -199.76, rotation: 0.101},
             {x: -114.34, y: -197.17, rotation: 0.107},
             {x: -109.34, y: -194.67, rotation: 0.113},
             {x: -104.37, y: -192.18, rotation: 0.12},
             {x: -99.86, y: -189.93, rotation: 0.125},
             {x: -95.24, y: -187.62, rotation: 0.131},
             {x: -90.94, y: -185.47, rotation: 0.136},
             {x: -86.7, y: -183.35, rotation: 0.142},
             {x: -82.63, y: -181.32, rotation: 0.147},
             {x: -78.86, y: -179.43, rotation: 0.151},
             {x: -75.27, y: -177.64, rotation: 0.156},
             {x: -71.85, y: -175.93, rotation: 0.16},
             {x: -68.51, y: -174.26, rotation: 0.164},
             {x: -65.45, y: -172.72, rotation: 0.168},
             {x: -62.56, y: -171.28, rotation: 0.172},
             {x: -59.76, y: -169.88, rotation: 0.175},
             {x: -57.22, y: -168.61, rotation: 0.178},
             {x: -54.79, y: -167.4, rotation: 0.182},
             {x: -52.61, y: -166.3, rotation: 0.184},
             {x: -50.54, y: -165.27, rotation: 0.187},
             {x: -48.71, y: -164.36, rotation: 0.189},
             {x: -47.01, y: -163.5, rotation: 0.191},
             {x: -45.58, y: -162.79, rotation: 0.193},
             {x: -44.2, y: -162.1, rotation: 0.195},
             {x: -43.1, y: -161.55, rotation: 0.196},
             {x: -42.13, y: -161.06, rotation: 0.197},
             {x: -41.35, y: -160.68, rotation: 0.198},
             {x: -40.75, y: -160.38, rotation: 0.199},
             {x: -40.32, y: -160.16, rotation: 0.2},
             {x: -40.08, y: -160.04, rotation: 0.2}
        ]
}
